// extracted by mini-css-extract-plugin
export default {"app":"App_app__ixjdX","content":"App_content__UHKdl","aboutContent":"App_aboutContent__1C0F+"};